import { Component, OnInit, Renderer2 } from '@angular/core';
import { AppConstant } from 'src/app/helper/class/app-constant';
import { MENU_ITEMS } from 'src/app/helper/class/page-menu';
import { UrlServices } from 'src/app/helper/class/url-services';
import { isEmptyObj, toggleMenu } from 'src/app/helper/class/utilityHelper';
import { menu } from 'src/app/helper/interface/menu-interface';
import { AuthService } from 'src/app/helper/service/auth.service';
import { SidebarToggleService } from 'src/app/helper/service/sidebar-toggle.service';
import { ModalService } from 'src/app/shared/service/modal.service';

@Component({
  standalone: false,
  selector: 'app-user-left-side-bar',
  templateUrl: './user-left-side-bar.component.html',
  styleUrls: ['./user-left-side-bar.component.scss']
})
export class UserLeftSideBarComponent implements OnInit {

  showDropdown: any = {}
  menuItems: any[] = [];
  logo = AppConstant.LOGO_SRC;

  constructor(
    private auth: AuthService,
    private modalService: ModalService,
    public sideBarServ: SidebarToggleService,
  ) { }

  ngOnInit(): void {
    this.setUserMenus()
  }

  setUserMenus() {
    const filterRoles: any = [], menuItems: menu[] = [] as menu[];

    MENU_ITEMS.forEach((item, index) => {
      const pM = this.checkPermission(item);
      //skip its false
      if (!pM) {
        return;
      }
      if (item.children?.length) {
        const chMenu: any = [];
        item.children.map((a: any) => {
          const chk = this.checkPermission(a);
          if (chk) {
            chMenu.push(a)
          }
        });
        if (!chMenu.length) {
          return;
        }
        item.children = chMenu;
      }
      menuItems.push(item);
    });
    this.menuItems = menuItems;
    this.menuItems.forEach((a: any) => this.showDropdown[a?.title] = false);
  }

  checkPermission(item: any) {
    if (isEmptyObj(item.data?.permission)) {
      return 'empty';
    }
    const mName = item.data?.permission.moduleName;
    const aName = item.data?.permission.actionName;
    const per = this.auth.checkPermission(mName, aName);
    return per;

  }
  toggleMenu(outside: boolean = false) {
    this.sideBarServ.toggleMenu(false, outside);
  }

  toogleSideBarPin() {
    this.sideBarServ.toogleSideBarPin();
  }

  parentMenuClick(m) {
    this.showDropdown[m?.title] = true;
    Object.keys(this.showDropdown).forEach((a) => {
      if (a != m?.title) {
        this.showDropdown[a] = false;
      }
    })
    // !+m?.children?.length ? !this.sideBarServ.tooglePin ? toggleMenu() : null : null
  }
}